export default __webpack_public_path__ + "static/media/bloodyhack6.48b103e8.png";